<script>
import { Dialog } from 'element-ui'

export default {
  name: 'KolRenewal',
  extends: Dialog,
  data() {
    return {
      dialogVisible: false,
      dialogTitle: '红人续签',
      formData: {
        artist_id: null,
        nickname: null,
        platform_name_aft: null,
        platform_code_aft: null,
        nature: null,
        contract_no: null,
        sign_date: null,
        term: null,
        renewal_years: null,
        renewal_cond: null,
        blogger_ratio: null
      },
      loadingSubmit: false,
      formFields: ['nickname', 'platform_name_aft', 'nature', 'sign_date', 'platform_code_aft'],
      rules: {
        nickname: [
          { required: true, message: '红人必选', trigger: 'blur' }
        ],
        platform_name_aft: [
          { required: true, message: '请输入签约后主平台', trigger: 'change' }
        ],
        nature: [
          { required: true, message: '请至少选择一个合约性质', trigger: 'change' }
        ],
        sign_date: [
          { type: 'date', required: true, message: '请选择时间', trigger: 'change' }
        ],
        term: [
          { required: true, message: '请输入', trigger: 'blur' }
        ]
      },
      platformOptions: [],
      typeMap: { 'again': '二次签约', 'renewal': '续签' }
    }
  },
  methods: {
    async show(row, type = 'again') {

      await this.getPlatforms()
      this.loadingSubmit = false
      this.dialogVisible = true
      this.dialogTitle = `添加合约记录：${row.nickname}（${this.typeMap[type] || '-'}）`
      // this.formData = {}
      this.formFields.forEach((field) => {
        // this.formData[field] = row[field]
        if (row[field])
          this.$set(this.formData, field, row[field])
        else
          this.$set(this.formData, field, '')
      })

      this.$set(this.formData, 'type', type)
      // this.$set(this.formData, 'sign_date', row.sign_date)
      // 签约开始时间：默认取上一个合约到期日期+1天，支持修改
      if (row.sign_end ) {
        const currentDate = new Date(row.sign_end)
        const futureDate = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate() + 1
        )
        const newSignDate = `${futureDate.getFullYear()}/${futureDate.getMonth() + 1}/${futureDate.getDate()}`
        this.$set(this.formData, 'sign_date', newSignDate)
      }

      // console.log('dd', newSignDate)
      // 来源签约合同ID
      this.$set(this.formData, 'artist_id', row.id)

      this.$set(this.formData, 'term', row.renewal_years)
      this.$set(this.formData, 'renewal_years', row.renewal_years)
      this.$set(this.formData, 'renewal_cond', row.renewal_cond)
      this.$set(this.formData, 'blogger_ratio', row.blogger_ratio)

    },
    async getPlatforms() {
      // 获取最新平台信息
      const { list } = await this.$api.getPlatforms()
      this.platformOptions = list || []
    },
    handleClose(done) {
      done()
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // console.log(this.formData)
          this.handleSave()
        } else {
          // console.log('error submit!!')
          return false
        }
      })
    },
    async handleSave() {
      this.loadingSubmit = true
      try {
        await this.$api.saveKolSignRecord(this.formData)
        this.dialogVisible = false
        this.$emit('refresh')
      } finally {
        this.loadingSubmit = false
      }
    }
  }

}
</script>

<template>
  <div>
    <el-dialog
      :title='dialogTitle'
      :visible.sync='dialogVisible'
      width='600px'
      center
      :before-close='handleClose'>
      <el-form :model='formData' ref='ruleForm' label-width='140px' label-position='right' label-suffix='：'>
        <el-form-item label='红人昵称'>
          <span>{{ formData.nickname }}</span>
        </el-form-item>
        <el-form-item label='签约后主平台' required>
          <el-select v-model='formData.platform_code_aft' placeholder='选择 签约后平台' :clearable='true'>
            <el-option
              v-for='item in platformOptions'
              :key='item.code'
              :label='item.name'
              :value='item.code'>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label='合约性质' required>
          <el-select v-model='formData.nature' placeholder='选择 合约性质' :clearable='true'>
            <el-option :label='`全约`' :value='1'>全约</el-option>
            <el-option :label='`商务约`' :value='2'>商务约</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label='签约开始日期' required>
          <el-date-picker
            v-model='formData.sign_date'
            type='date'
            format='yyyy年MM月dd日'
            value-format='yyyy/MM/dd'
            placeholder='选择签约开始日期'>
          </el-date-picker>
          <!--          <el-input v-model='formData.sign_date' placeholder='签约开始日期'></el-input>-->
        </el-form-item>
        <el-form-item label='合约年限' required>
          <el-input v-model='formData.term' placeholder='本次续约的合约年限(来自上份合约)' clearable>
            <span slot='append'>年</span>
          </el-input>
        </el-form-item>
        <el-form-item label='续约年限'>
          <el-input v-model='formData.renewal_years' placeholder='下次续约的年限' clearable>
            <span slot='append'>年</span>
          </el-input>
        </el-form-item>
        <el-form-item label='续约条件（万）' required>
          <el-input v-model='formData.renewal_cond' placeholder='下次续约的条件' clearable></el-input>
        </el-form-item>
        <el-form-item label='博主分成比例' required>
          <el-input v-model='formData.blogger_ratio' placeholder='本次续约后的博主分成比例' clearable>
            <span slot='append'>%</span>
          </el-input>
        </el-form-item>
        <el-form-item label='合同编号'>
          <el-input v-model='formData.contract_no' placeholder='输入合同编号' clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot='footer' class='dialog-footer'>
        <!--    <el-button @click='dialogVisible = false'>取 消</el-button>-->
        <el-button type='primary' size='small' @click='submitForm("ruleForm")' :loading='loadingSubmit'
                   :disabled='loadingSubmit'>确定添加</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style scoped>
::v-deep .el-dialog {
  background: #ffffff;
}

::v-deep .el-dialog__header {
  background: #ffffff;
}

::v-deep .el-dialog__body {
  background: #ffffff;
}

::v-deep .el-dialog__footer {
  background: #ffffff;
}
</style>
